import { TopicServiceLocal } from "./TopicServiceLocal";
import { TopicServiceFirestore } from "./TopicServiceFirestore";
export class TopicServiceFactory {
    static createLocal() {
        return new TopicServiceLocal();
    }
    static createFirestore(firestore) {
        if (!firestore) {
            throw new Error("Firestore instance is required for Firebase service");
        }
        return new TopicServiceFirestore(firestore);
    }
}
